import initialState from '../../initialState';
import { EnvironmentSettingActions } from '../../constants';

const reducer = (state = initialState.EnvironmentSetting, action = {}) => {
  switch (action.type) {
    case EnvironmentSettingActions.SET_IS_OPEN:
      return { ...state, isOpen: action.isOpen };
    case EnvironmentSettingActions.RESTORE_ENV:
      return {
        ...state,
        customUrl: action.envInfo.customUrl,
        username: action.envInfo.username,
        password: action.envInfo.password,
        contentGroup: action.envInfo.contentGroup,
      };
    case EnvironmentSettingActions.UPDATE_URL:
      return { ...state, customUrl: action.customUrl };
    case EnvironmentSettingActions.UPDATE_USERNSME:
      return { ...state, username: action.username };
    case EnvironmentSettingActions.UPDATE_PASSWORD:
      return { ...state, password: action.password };
    case EnvironmentSettingActions.UPDATE_CONTENT_GROUP:
      return { ...state, contentGroup: action.contentGroup };
    case EnvironmentSettingActions.CLEAR_ENV:
      return {
        ...state,
        customUrl: '',
        username: '',
        password: '',
        contentGroup: '',
      };
    default:
      return state;
  }
};
export default reducer;
